<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-list class="pb-0">
            <v-list-tile>
            <v-list-tile-action>
              <v-icon color="green">person_outline</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title class="ext-link">
                <span class="green--text">Welcome {{user.firstName}}</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-list dense class="pt-0">
          <template v-for="item in items">
            <v-layout row v-if="item.heading" align-center :key="item.heading">
              <v-flex xs6>
                <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
              </v-flex>
              <v-flex xs6 class="text-xs-center">
                <a href="#!" class="body-2 black--text">EDIT</a>
              </v-flex>
            </v-layout>
            <v-list-group
              v-else-if="item.children"
              v-model="item.model"
              :key="item.text"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon
            >
              <v-list-tile slot="activator">
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-for="(child, i) in item.children" :key="i" :to="path">
                <v-list-tile-action v-if="child.icon">
                  <v-icon :color="icon.color">{{ child.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ child.text }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>
            <v-list-tile v-else :key="item.text" :to="item.path">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>

                <!-- external links -->
        <v-list dense>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>help</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title class="ext-link-sidebar">
                  <a :href="`${webUrl}/how-it-works`" target="_blank" class="ext-link-sidebar">How It Works</a>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- two -->
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>assignment</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title class="ext-link-sidebar">
                  <a :href="`${webUrl}/terms`" target="_blank" class="ext-link-sidebar">Our Terms</a>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- three -->
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>policy</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title class="ext-link-sidebar">
                  <a :href="`${webUrl}/privacy`" target="_blank" class="ext-link-sidebar">Privacy Policy</a>
               </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon>view_stream</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title class="ext-link-sidebar">
                  <a :href="`${webUrl}/our-blogspot`" target="_blank" class="ext-link-sidebar">Blog</a>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon>view_stream</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title class="ext-link-sidebar">
                  <a :href="`${webUrl}/blog/outreach-partners-program`" target="_blank" class="ext-link-sidebar">Partners Program</a>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- <v-list-tile>
            <v-list-tile-action>
              <a href="https://www.facebook.com/eWak.Cloud.Ltd" target="_blank" class="mr-3">
                <img src="@/assets/fb.png" class="icons">
              </a>
            </v-list-tile-action>
            <v-list-tile-action>
              <a href="https://twitter.com/Ewak_Cloud_Ltd" target="_blank" class="mx-3">
                <img src="@/assets/twitter.png" class="icons">
              </a>
            </v-list-tile-action>
            <v-list-tile-action>
              <a href="https://www.instagram.com/ewak.cloud.ltd/" target="_blank" class="mx-3">
                <img src="@/assets/instagram.png" class="icons">
              </a>
            </v-list-tile-action>
            <v-list-tile-action>
              <a :href="`https://wa.me/254777221441`" class="mx-3">
                <img src="@/assets/whatsapp.png" style="width: 39px; height: 39px;" alt="">
              </a>
            </v-list-tile-action>
          </v-list-tile> -->
        </v-list>
        <!-- end -->
      </v-card>
    </v-flex>
  </v-layout>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["webUrl"]),
    ...mapGetters(['user']),
  },
  data() {
    return {
      items: [
        { icon: "person_outline", text: "My Profile", path: "/vip_sonko/profile" },
        { icon: "add", text: "Post a Job", path: "/vip_sonko/create/job" },
        { icon: "build", text: "My jobs", path: "/vip_sonko/jobs/active" },
        {
          icon: "view_stream",
          color: "orange",
          text: "Experts in My Location",
          path: "/vip_sonko/landing"
        },
        {
          icon: "view_stream",
          color: "orange",
          text: "All Experts",
          path: "/vip_sonko/all/experts"
        },
        { icon: "credit_card", text: "Payments", path: "/vip_sonko/payments" }
      ]
    };
  }
};
</script>

<style scoped>
.ext-link {
  color: #000;
  text-decoration: none;
  font-size: 14px
}
.icons {
  width: 30px; 
  height: 30px;
}
.ext-link span {
  text-transform: uppercase;
}
.ext-link-sidebar {
  color: rgba(0,0,0,0.87);
  text-decoration: none;
}
</style>